export const openWindow = (href: string | undefined, windowName: string = '_system', windowFeatures?: string) => {
    const newWindow = window.open(href, windowName, windowFeatures);
    if (newWindow) {
        newWindow.opener = null;
    }
};
